import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Switch, Modal } from 'antd';

import logo from 'assets/logo.png';
import logoSmall from 'assets/logo-small.png';

import Menus from './Menu';
import styles from './Layout.less';


const Sider = ({ siderFold, darkTheme, location, changeTheme, navOpenKeys, changeOpenKeys, menu, resetTourGuide }) => {
  const menusProps = {
    menu,
    siderFold,
    darkTheme,
    location,
    navOpenKeys,
    changeOpenKeys,

  };

  const helpClick = () => {
    Modal.confirm({
      title: 'Xem lại các chỉ dẫn phần mềm',
      content: 'Bật chỉ dẫn để xem lại các hướng dẫn sử dụng phần mềm',
      okText: 'Bật chỉ dẫn',
      cancelText: 'Bỏ qua',
      onOk: resetTourGuide,
    });
  };

  return (
    <div>
      <div className={styles.logo}>
        {siderFold ? <img alt="1ketoan small logo" src={logoSmall} /> : <img alt="1ketoan logo" src={logo} />}
      </div>

      <Menus {...menusProps} />

      {!siderFold ? (
        <div className={styles.switchtheme}>
          <a id="resetTourBtn" onClick={helpClick}><Icon type="question-circle-o" />Hướng dẫn</a>
          <Switch onChange={changeTheme} defaultChecked={darkTheme} checkedChildren="Tối" unCheckedChildren="Sáng" />
        </div>
      ) : ''}
    </div>
  );
};

Sider.propTypes = {
  menu: PropTypes.array,
  siderFold: PropTypes.bool,
  darkTheme: PropTypes.bool,
  location: PropTypes.object,
  changeTheme: PropTypes.func,
  navOpenKeys: PropTypes.array,
  changeOpenKeys: PropTypes.func,
};

export default Sider;



// WEBPACK FOOTER //
// ./src/components/Layout/Sider.js